var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',[_c('el-header',{attrs:{"height":"90"}},[_c('Header',{attrs:{"styleObject":_vm.styleObject}})],1),_c('el-main',[_c('router-view')],1),_c('el-footer',[_c('Footer',{attrs:{"styleTop":_vm.styleTop}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }